import {
  ToggleSwitch as ToggleSwitchComponent,
  ToggleSwitchProps,
} from '@randstad-lean-mobile-factory/react-components-core';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../ErrorMessage';

import { Props } from './ToggleSwitch.types';

export const ToggleSwitch = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  defaultValue,
  disabled,
  formFieldClassName,
  ...toggleSwitchProps
}: Props<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  return (
    <div className={formFieldClassName}>
      <ToggleSwitchComponent
        {...toggleSwitchProps}
        checked={field.value as ToggleSwitchProps['checked']}
        onCheckStatusChange={field.onChange}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
